import { createStore } from 'vuex'

export default createStore({
  state: {
    actionurl: null,
    configurl: null,
    bID: 0,
    questions: [],
  },
  mutations: {
    updateActionUrl(state, actionurl) {
      state.actionurl = actionurl
    },
    updateConfigUrl(state, configurl) {
      state.configurl = configurl
    },
    updateBID(state, bID) {
      state.bID = bID
    },
  },
  getters: {},
  actions: {},
})
